// DS1.7.11
import React from 'react';
import classnames from 'classnames';
import Locked16 from './16x16/Locked';
import Unlocked16 from './16x16/Unlocked';
import Locked24 from './24x24/Locked';
import Unlocked24 from './24x24/Unlocked';
import Locked32 from './32x32/Locked';
import Unlocked32 from './32x32/Unlocked';
import Locked40 from './40x40/Locked';
import Unlocked40 from './40x40/Unlocked';
import s from './TierBadge.scss';
var lockedSizes = {
    16: Locked16,
    24: Locked24,
    32: Locked32,
    40: Locked40,
};
var unlockedSizes = {
    16: Unlocked16,
    24: Unlocked24,
    32: Unlocked32,
    40: Unlocked40,
};
var TierBadge = function (_a) {
    var size = _a.size, isLocked = _a.isLocked, className = _a.className, useSecondaryColor = _a.useSecondaryColor;
    var Component = isLocked ? lockedSizes[size] : unlockedSizes[size];
    return (React.createElement(Component, { className: classnames(s['root'], s["size-".concat(size)], useSecondaryColor && s['secondary-color'], className) }));
};
TierBadge.displayName = 'TierBadge';
export default TierBadge;
//# sourceMappingURL=TierBadge.js.map